import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blog-footer',
  templateUrl: './blog-footer.component.html',
  styleUrls: ['./blog-footer.component.css'],
})
export class BlogFooterComponent implements OnInit {
  private loadNavigateByUrl = {
    faq: '/faq',
    precontact: '/faq/contact-us',
    privacypolicy: '/faq/privacy-policy',
    termsofservice: '/faq/terms-of-service',
    residential: '/',
    giveback: '/giveback',
    precontactmob: '/pre-contact',
    privacypolicymob: '/privacy-policy',
    termsofservicemob: '/terms-of-service',
    commercial: '/commercial',
    blog: '/blog',
  };
  licenseHG: string;
  constructor(private router: Router) {}

  ngOnInit() {
    this.licenseHG = `${new Date().getFullYear()} Honest Gorilla Inc. All Rights Reserved.`;
  }

  footerClick(selectedMenu) {
    const scrollInitial = document.getElementsByTagName('html');
    scrollInitial[0].classList.add('letsgo');
    this.router.navigateByUrl(this.loadNavigateByUrl[selectedMenu]);
  }
}
